// DÉSACTIVÉ le 2026-09-12 — fenêtre promo glissante (J-5 → J, « ce soir à minuit »,
// « Mise à jour des prix en cours ») retirée : fausse urgence interdite par la règle
// interne LPC d'avril 2026. Remplacé par assets/lpc-promo-countdown.js (date de fin
// fixe, multilingue). Ce fichier n'est plus chargé par layout/theme.liquid ; il est
// conservé vide pour neutraliser tout cache ou référence résiduelle.
(function () { 'use strict'; window.LPCPromoClock = undefined; })();
